module.exports = __webpack_public_path__ + "static/media/meter2.d1ac0613.svg";